/* eslint-disable */
import HttpService from '../HttpService';

export default class CoverageReasonService {
  constructor() {
    this._httpService = new HttpService('/sdi/coverage-extension-reason');
  }

  async FetchCoverage() {
    return await this._httpService.get('');
  }
};
